import type { ReactNode } from 'react';
import { Logo } from '../brand/Logo';

/**
 * Full-screen centred message on the cream ground — the shared frame for the
 * recovery and refusal screens (no network, service unavailable, update
 * required, no admin access, not found). Title is Montserrat; copy follows
 * the handoff: short, blame-free, action-first, terminal period.
 */
export function CenteredPage({
  title,
  children,
  actions,
  showLogo = true,
  as: Frame = 'main',
}: {
  title: ReactNode;
  children?: ReactNode;
  actions?: ReactNode;
  showLogo?: boolean;
  /** `div` inside the shell, whose content area is already the page's <main>. */
  as?: 'main' | 'div';
}) {
  return (
    <Frame className="flex min-h-full items-center justify-center bg-page px-6 py-12 font-body">
      <div className="flex w-full max-w-[440px] flex-col items-center gap-5 text-center">
        {showLogo && <Logo variant="brown" height={34} />}
        <h1 className="m-0 font-heading text-[26px] font-bold tracking-[-.01em] text-brown-deep">{title}</h1>
        {children && <div className="text-[15px] leading-[1.55] text-muted">{children}</div>}
        {actions && <div className="flex w-full flex-col gap-3">{actions}</div>}
      </div>
    </Frame>
  );
}
